import { create } from "zustand";
import type { ZoneDesignResult } from "../lib/zoneDesign";

// "Create zones & order sampling" session: the table row starts it the map (ZoneCreator) computes
// the Mahalanobis zone design client-side, previews it and ends in the Z2 save + SS2 order.
interface ZoneCreateState {
  fieldId: string | null; // non-null = a zone-create session is active (for this field)
  kOverride: number | null; // null = use the auto-picked count
  // server-suggested zone count: the 4-acre-floor max.
  suggestedK: number | null;
  result: ZoneDesignResult | null;
  status: "idle" | "computing" | "ready" | "error";
  error: string | null;
  start: (fieldId: string) => void;
  end: () => void;
  setK: (k: number | null) => void;
  setSuggested: (k: number) => void;
  computing: () => void;
  ready: (result: ZoneDesignResult) => void;
  fail: (message: string) => void;
}

export const useZoneCreateStore = create<ZoneCreateState>((set) => ({
  fieldId: null,
  kOverride: null,
  suggestedK: null,
  result: null,
  status: "idle",
  error: null,
  start: (fieldId) =>
    set({
      fieldId,
      kOverride: null,
      suggestedK: null,
      result: null,
      status: "idle",
      error: null,
    }),
  end: () =>
    set({
      fieldId: null,
      kOverride: null,
      suggestedK: null,
      result: null,
      status: "idle",
      error: null,
    }),
  setK: (kOverride) => set({ kOverride }),
  setSuggested: (suggestedK) => set({ suggestedK }),
  computing: () => set({ status: "computing", error: null }),
  ready: (result) => set({ result, status: "ready", error: null }),
  fail: (error) => set({ status: "error", error }),
}));
